<template>
    <div>
        <Toast v-for="(toast, index) in toasts" :key="index" :tipo="toast.tipo" :mensaje="toast.mensaje" />
    </div>
</template>

<script setup>
import { ref } from "vue";
import Toast from "../Toast.vue";

const toasts = ref([]);

function agregarToast(mensaje, tipo = "info") {
    toasts.value.push({ mensaje, tipo });

    setTimeout(() => {
        toasts.value.shift(); // elimina el toast más viejo
    }, 5000);
}

// Exponer globalmente
if (!window.llamarToast) {
    window.llamarToast = agregarToast;
}
</script>
